import { IQboCustomerMappingInput, IQboCustomerMappingRow } from '../interfaces/qbo'

export type IQboCustomerMappingChanges = Partial<
  Pick<
    IQboCustomerMappingRow,
    'qboCustomerId' | 'qboCustomerName' | 'qboAccountId' | 'qboAccountName'
  >
>

// The stored fields a mapping save writes. The customer and the account are each set
// only when the input names them, so saving one never clears the other; '' clears.
export const pickCustomerMappingChanges = (
  mapping: IQboCustomerMappingInput,
): IQboCustomerMappingChanges => ({
  ...('qboCustomerId' in mapping
    ? {
        qboCustomerId: mapping.qboCustomerId || null,
        qboCustomerName: mapping.qboCustomerName || null,
      }
    : {}),
  ...('qboAccountId' in mapping
    ? {
        qboAccountId: mapping.qboAccountId || null,
        qboAccountName: mapping.qboAccountName || null,
      }
    : {}),
})
